import { useState, useEffect, useMemo } from 'react';
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import Icon from '../Assets/Icon/CustomIcon';

const weatherConfig = {
  Clear: {
    icon: Icon.LightMode,
    color: '#F59E0B',
  },
  Clouds: {
    icon: Icon.Cloud,
    color: '#64748B',
  },
  Rain: {
    icon: Icon.Rainy,
    color: '#3B82F6',
  },
  default: {
    icon: Icon.LightMode,
    color: '#F59E0B',
  },
};

const DEFAULT_LAT = 37.5665;
const DEFAULT_LON = 126.978;

const useWeather = () => {
  const [weatherData, setWeatherData] = useState({
    temp: '--',
    condition: 'default',
  });

  useEffect(() => {
    const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;

    const fetchWeather = async (lat, lon) => {
      const url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${API_KEY}&units=metric`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.main) {
          setWeatherData({
            temp: Math.round(data.main.temp),
            condition: data.weather[0].main,
          });
        }
      } catch (err) {
        console.error(err);
      }
    };

    const getLocationAndFetch = async () => {
      if (Capacitor.isNativePlatform()) {
        try {
          const status = await Geolocation.requestPermissions();
          if (status.location !== 'granted') {
            fetchWeather(DEFAULT_LAT, DEFAULT_LON);
            return;
          }
          const position = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 60000,
          });
          const { latitude, longitude } = position.coords;
          fetchWeather(latitude, longitude);
        } catch {
          fetchWeather(DEFAULT_LAT, DEFAULT_LON);
        }
      } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            fetchWeather(latitude, longitude);
          },
          () => {
            fetchWeather(37.5665, 126.978);
          }
        );
      }
    };

    getLocationAndFetch();
  }, []);

  return useMemo(() => {
    const config =
      weatherConfig[weatherData.condition] || weatherConfig.default;
    return {
      temp: weatherData.temp,
      WeatherIcon: config.icon,
      iconColor: config.color,
    };
  }, [weatherData]);
};

export default useWeather;
